<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="150px">
      <div class="updateinfo">
  <div class="left">
    <el-row>
        <el-col style="padding: 20px;">
            <el-avatar :size="100" :src="userInfo.avatar"></el-avatar>
        </el-col>
    </el-row>
       
          
          
          
  </div>
  <div class="right">
    <el-row>
        <el-col>
            <div>
    <span style="font-size:20px ;color: #0c6be1;;font-weight: bold;"> {{userInfo.nickname}}</span>
    <span style="margin-left:30px ;"><el-button type="primary" size="small" plain style="margin-right: 20px;">编辑资料</el-button></span>
    <span><el-button type="warning" size="small" plain style="margin-right: 20px;">修改密码</el-button></span>
  </div>
           
        </el-col>
    </el-row>
    <el-row>
        <el-col>
            <div>
    
    <span><el-image style="width: 50px; height: 50px":src="userInfo.limiticon":fit="contain"></el-image></span>
  </div>
           
        </el-col>
    </el-row>
    <el-row>
  <el-col :span="24">
    <el-descriptions class="margin-top"  :column="3" :size="size" style="padding-left: 5px;">
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-user"></i>
        ID
      </template>
      {{ userInfo.username}}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-info"></i>
        性别
      </template>
      <el-tag size="small"> {{ userInfo.sex}}</el-tag>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-location-outline"></i>
        年龄
      </template>
      <el-tag size="small"> {{ userInfo.age}}</el-tag>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-mobile-phone"></i>
        手机号
      </template>
      {{ userInfo.phone}}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        联系地址
      </template>
     {{ userInfo.address}}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-tickets"></i>
        个人简介
      </template>
      {{ userInfo.remark}}
    </el-descriptions-item>
  </el-descriptions>
</el-col>
</el-row>            
          <!-- <el-form-item label="账号" prop="account">
            <el-input v-model="form.account" disabled style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="昵称" prop="account">
            <el-input v-model="form.account" disabled style="width: 300px;"></el-input>
          </el-form-item>
          
          <el-form-item label="密码" prop="area">
            <el-input v-model="form.area"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-switch
              v-model="form.sex"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="男"
              inactive-text="女"
              :active-value= "1"
               :inactive-value= "0"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="年龄" prop="hobby">
            <el-input v-model="form.hobby"></el-input>
          </el-form-item>
          <el-form-item label="职业" prop="work">
            <el-input v-model="form.work"></el-input>
          </el-form-item>
                    <el-form-item label="个性签名" prop="design">
            <el-input v-model="form.design"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobilePhoneNumber">
            <el-input v-model="form.mobilePhoneNumber"></el-input>
          </el-form-item>
          
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="submit">提 交</el-button>
            </span>
          -->
          
  </div>
  </div>
  </el-form>
 


    </div>
  

</template>
<script>
export default {
    name: "PersonalDia",
    data() {
        return {
        currentDate: new Date(),
        dialogVisible: false,
        userInfo:{
           username:'starloveme',
           sex:'男',
           nickname :'视弘文创',
           avatar: '',
           age:'25',
           phone:'17732066892',
           address:'邯郸市邯山区',
           remark:'热爱运动，积极阳光',
           limiticon:''

        },
        form: {
            avatar: "",
            password: "",
            nickname: "",
            age: Number,
            email: "",
            mobilePhoneNumber: "",
            sex: Number,
            id: Number,
            account: "",
            area: "",
            hobby: "",
            work: "",
            design: "",
        },
        rules: {
            nickname: [
            { required: true, message: "昵称不能为空", trigger: "blur" },
            ],
            password: [
            { required: true, message: "账号密码不能为空", trigger: "blur" },
            ],
        },
        };
    },
    created() {
    
    this.userInfo.avatar = require('@/assets/image/user.jpg');
    this.userInfo.limiticon= require('@/assets/image/gold.png');
  },

 }
</script>
<style scoped>
.time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

.updateinfo {
    padding-top: 20px;
  height: 700px;
  overflow: auto;
  border-radius: 10px;
  border: solid #e6e3e3 1px;
}
.left {
  /* width: 330px; */
  float: left;
}
.right {
  overflow: hidden;
}
</style>
